jQuery(function ($) {
  const appUrl = window["app_url"];
  let currentRequest = null;
  let membershipWrapper = $("#memberships");
  const customerSig = window["customer_sig"] || "";
  const customerId = $("#customer_id").val();
  const postData = {
    customer_sig: customerSig,
    customer_id: customerId
  };

  currentRequest = $.ajax({
    type: "POST",
    url: appUrl + "/customer/membership-summary",
    data: JSON.stringify(postData),
    contentType: "application/json; charset=utf-8",
    beforeSend: function () {
      if (currentRequest != null) {
        currentRequest.abort();
      }
    },
    success: function (data) {
      // console.log(data);
      let title = data["Title"] ?? '';
      let html = "<ul class='membership-info'>";
      html +=
        "<li><b>Title: </b>" + title + "</li>" +
        "<li><b>Email: </b>" + data["Email"] + "</li>" +
        "<li><b>First Name: </b>" + data["FirstName"] + "</li>" +
        "<li><b>Last Name: </b>" + data["LastName"] + "</li>" +
        "<li><b>Telephone: </b>" + data["Mobile"] + "</li>";

      if (Array.isArray(data["MembershipSummaries"])) {
        // html += "<li><b>Membership info: </b>";
        // html += "<ul>";
        data["MembershipSummaries"].forEach(function (mbsInfo) {
          if (mbsInfo["Status"] === "ACTIVE") {
            html += "<li><b>Membership Tier: </b>" + mbsInfo["Type"] + "</li>" ;
            // html +=
            //   "<li>" + "<b>Tier:</b> " + mbsInfo["Tier"] + "</li>" +
            //   "<li>" + "<b>Type:</b> " + mbsInfo["Type"] + "</li>" +
            //   "<li>" + "<b>Status:</b> " + mbsInfo["Status"] + "</li>";

            // html +=
            //   "<li><b>Account Summaries:</b>" +
            //   "<ul>";
            mbsInfo["AccountSummaries"].forEach(function (accSum, index) {
              if (accSum["PointType"] === "C21 Points") {
                html += "<li><b>Comocredit Balance:</b> " + accSum["Balance"] + "</li>" ;
                // html +=
                //   "<li><b>Account " + (index + 1) + ":</b>" +
                //   "<ul>" +
                //   "<li><b>Point Type:</b> " + accSum["PointType"] + "</li>" +
                //   "<li><b>Balance:</b> " + accSum["Balance"] + "</li>" +
                //   "</ul>" +
                //   "</li>";
              }
            });
            // html +=
            //   "</ul>" +
            //   "</li>";
          }
        });
        // html +=
        //   "</ul>" +
        //   "</li>";
      }

      html += "</ul>";
      membershipWrapper.html(html);
    },
    error: function (xhr, ajaxOptions, thrownError) {
      const res = xhr.responseJSON;
      const errorsHtml = '<ul>' +
        ' <li>' + res.message + '</li>' +
        '</ul>';

      membershipWrapper.html(errorsHtml);
    }
  });
});
